/* Pia überall (30.10.2026): schwebender Knopf im angemeldeten CRM, öffnet ein Seitenfenster mit demselben Chat wie /pia.
   Der Inhaber chattet hier; die Empfänger der Briefings (31.10.2026: Cagla) sehen nur ihren Verlauf und arbeiten die Karten ab.
   GET /api/assistenz/status antwortet 404 (Schalter aus) bzw. 403 (kein Zugang) → nichts zeigen.
   Pia bekommt die Seite mit (Seitenart + auf der Lead-Ansicht die Lead-ID): „Buch ihr Mittwoch 19 Uhr ein“ meint den offenen Lead.
   Kürzel: ⌘J / Strg+J (⌘K bleibt die Seitensuche). Bestätigungskarten laufen nie per Sprache, nur per Klick. */
import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Bot, X } from 'lucide-react';
import api from '@/lib/api';
import PiaThread from '@/components/PiaThread';

const LEAD = /^\/leads\/([A-Za-z0-9_-]{3,64})\/?$/;

/* Kontext der Seite für Pia: nur der Pfad und die Lead-ID – der Server prüft beides und gibt dem Modell weder Pfad noch Namen. */
export function kontextVon(pfad) {
  const m = LEAD.exec(pfad || '');
  return { seite: pfad || '', ...(m ? { lead_id: m[1] } : {}) };
}

export default function PiaSchwebeknopf() {
  const ort = useLocation();
  const [s, setS] = useState(null);
  const [offen, setOffen] = useState(false);
  const pfad = useRef(ort.pathname);
  pfad.current = ort.pathname;
  const lade = useCallback(() => api.get('/assistenz/status').then((r) => setS(r.data)).catch(() => setS(null)), []);
  useEffect(() => { lade(); }, [lade]);

  const kontext = useCallback(() => kontextVon(pfad.current), []);
  const sichtbar = !!s?.aktiv;
  const fragt = !!s?.darf_fragen;

  useEffect(() => {
    if (!sichtbar) return undefined;
    const taste = (e) => {
      if ((e.metaKey || e.ctrlKey) && !e.shiftKey && !e.altKey && e.key.toLowerCase() === 'j') { e.preventDefault(); setOffen((o) => !o); }
      else if (e.key === 'Escape') setOffen(false);
    };
    window.addEventListener('keydown', taste);
    return () => window.removeEventListener('keydown', taste);
  }, [sichtbar]);

  if (!sichtbar || ort.pathname.startsWith('/pia')) return null;     // auf /pia gibt es denselben Chat schon
  const k = kontextVon(ort.pathname);
  return (
    <>
      {!offen && (
        <button type="button" onClick={() => setOffen(true)} data-testid="pia-schwebeknopf" aria-label="Pia öffnen (Strg oder Befehlstaste plus J)" title="Pia (⌘J)"
          className="fixed z-40 right-4 bottom-20 md:bottom-6 inline-flex items-center justify-center w-14 h-14 rounded-full bg-marke text-white shadow-lg hover:opacity-90 focus:outline-none focus:ring-4 focus:ring-marke/40">
          <Bot className="w-6 h-6" aria-hidden="true" />
          {s.ungelesen > 0 && <span className="absolute -top-1 -right-1 min-w-[20px] h-5 rounded-full bg-background text-marke text-[11px] font-bold px-1 flex items-center justify-center border border-marke">{s.ungelesen}</span>}
        </button>
      )}
      {offen && (
        <aside role="dialog" aria-label="Pia" data-testid="pia-seitenfenster"
          className="fixed z-50 top-0 right-0 h-full w-full sm:w-[420px] bg-background border-l border-border shadow-2xl flex flex-col">
          <header className="flex items-center justify-between gap-2 px-4 h-14 border-b border-border shrink-0">
            <span className="flex items-center gap-2 text-sm font-bold"><Bot className="w-4 h-4 text-marke" aria-hidden="true" /> Pia
              {!fragt && <span className="text-xs font-normal text-muted-foreground">· deine Briefings</span>}
              {fragt && k.lead_id && <span className="text-xs font-normal text-muted-foreground">· kennt die offene Person</span>}</span>
            <button type="button" onClick={() => setOffen(false)} aria-label="Schließen" data-testid="pia-seitenfenster-zu"
              className="inline-flex items-center justify-center w-10 h-10 rounded-md hover:bg-muted"><X className="w-5 h-5" aria-hidden="true" /></button>
          </header>
          <div className="flex-1 min-h-0 p-3 overflow-y-auto">
            {fragt
              ? <PiaThread darfFragen gespraech hoehe="h-[calc(100vh-330px)] min-h-[160px]" kontext={kontext} onGelesen={lade} />
              : <PiaThread darfFragen={false} hoehe="h-[calc(100vh-150px)] min-h-[160px]" onGelesen={lade} />}
          </div>
        </aside>
      )}
    </>
  );
}
